module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-LightItalic.1e250944.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-LightItalic.woff
// module id = 935
// module chunks = 0